import React from "react";
import ReactDOM from "react-dom";
import ImageCardWithList from "./CardAndListDemo_v01";

const CardListDemoPage: React.FC = () => {
  return (
    <ImageCardWithList
      imageUrl="https://via.placeholder.com/400x300"
      cardTitle="Beautiful View"
      cardText="Enjoy the scenery from your card on the left."
      listItems={["Item One", "Item Two", "Item Three", "Item Four"]}
    />
  );
};

export default CardListDemoPage;
